import React, { useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import produitDataFetcher from "dataProvider/Produit";
import { IntlContext, ListContext } from "context";
import usePromise from "helpers/usePromise";
import VieProduit from "./VieProduit";
import ValeursNutritionnelles from "./ValeursNutritionnelles";
import Ingredients from "./Ingredients";
import EtiquetageNutritionnelSimplifie from "./EtiquetageNutritionnelSimplifie";
import LabelLogos from "./LabelLogos";
import Allegations from "./Allegations";
import Informations from "./Informations";
import Descriptions from "./Descriptions";
import Loader from "ui/Loader";
import Button from "ui/Button";
import { useHistory } from "react-router-dom";

interface Match {
    id: string;
}

export type ViewProps = {
    toNext: boolean;
    setToNext: (value: boolean) => void;
    toBack: boolean;
    setToBack: (value: boolean) => void;
};

const ViewComponent: React.FC<ViewProps> = ({ toNext, setToNext, toBack, setToBack }) => {
    const intl = useContext(IntlContext);
    const listCtxt = useContext(ListContext);
    const navigate = useHistory();
    const { id } = useParams<Match>();
    const [moreVisibleVn, setMoreVisibleVN] = useState<boolean>(false);
    const [moreVisibleIng, setMoreVisibleIng] = useState<boolean>(false);
    const { isLoading, hasError, error, data } = usePromise(produitDataFetcher.one, id);
    const num = listCtxt.data.findIndex((s) => s.id === Number(id));
    let before = true,
        after = true;

    const goToPage = (page: number) => {
        listCtxt.changeFetcherParams(
            Object.assign({}, listCtxt.data.active_filters, {
                page,
                order: listCtxt.data.pager.order,
                direction: listCtxt.data.pager.direction,
                per_page: listCtxt.data.pager.per_page,
            })
        );
    };

    const goToNextPage = (step: number) => {
        let number = 0;
        let predicate = step < 0 ? num === 0 : num === listCtxt.data.length - 1;
        if (predicate) {
            step < 0 ? setToBack(true) : setToNext(true);
            goToPage(listCtxt.data.pager.current_page + step);
            return;
        } else {
            number = listCtxt.data[num + step].id;
        }
        navigate.push("/produit/".concat(number.toString()));
    };

    if (hasError) {
        throw error;
    }

    if (isLoading || !data || listCtxt.isLoading) {
        return <Loader message={intl.formatMessage("generic.loader.loading.label")} />;
    }

    if (toNext === true) {
        setToNext(false);
        let number = listCtxt.data[0].id;
        navigate.push("/produit/".concat(number.toString()));
    }

    if (toBack === true) {
        setToBack(false);
        let number = listCtxt.data[listCtxt.data.length - 1].id;
        navigate.push("/produit/".concat(number.toString()));
    }

    if (num === 0) {
        if (listCtxt.data.pager.current_page === 1) {
            before = false;
        }
    } else if (num === -1) {
        before = false;
    }
    if (num === listCtxt.data.length - 1) {
        if (listCtxt.data.pager.current_page === listCtxt.data.pager.last_page) {
            after = false;
        }
    } else if (num === -1) {
        after = false;
    }

    return (
        <React.Fragment>
            <header className="header-product"></header>

            <div className="container">
                <div className="product-page">
                    <Link className="cta cta--link button-back" to="/">
                        <i className="icon icon-arrow-left"></i>
                        {intl.formatMessage("produit.fiche.label.retour_aux_resultats")}
                    </Link>

                    <div className="product-informations">
                        <Descriptions produit={data}>
                            <VieProduit produit={data} />
                        </Descriptions>

                        <ValeursNutritionnelles
                            produit={data}
                            more={{
                                visible: moreVisibleVn,
                                onClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                                    e.preventDefault();
                                    setMoreVisibleVN(true);
                                },
                            }}
                        />

                        <Ingredients
                            produit={data}
                            more={{
                                visible: moreVisibleIng,
                                onClick: (e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                                    e && e.preventDefault();
                                    setMoreVisibleIng(true);
                                },
                            }}
                        />

                        <EtiquetageNutritionnelSimplifie produit={data} />

                        <LabelLogos produit={data} />

                        <Allegations produit={data} />

                        <Informations produit={data} />
                    </div>
                    <div className="container-next-page">
                        {before ? (
                            <Button className="cta cta--link button-back-bis" onClick={() => goToNextPage(-1)}>
                                <i className="icon icon-arrow-left"></i>
                                {intl.formatMessage("produit.fiche.label.before")}
                            </Button>
                        ) : null}
                        {after ? (
                            <Button className="cta cta--link button-back-bis" onClick={() => goToNextPage(1)}>
                                {intl.formatMessage("produit.fiche.label.after")}
                                <i className="icon icon-arrow-right"></i>
                            </Button>
                        ) : null}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ViewComponent;
